import {connect} from "react-redux";
import YourQuestion from "../../../../components/Home/Pages/YourQuestions/YourQuestion";
import {
getQuestionsAnswers,
updateResponse,
updateQuestion,
setReasonOfUnsatisfiedResponse
} from "../../../../actions/QuestionsAndAnswers";

const MapStateToProps = (state, ownProps) => {

const questionsAndAnswers = state.questionsAndAnswers.questionsAndAnswers;
const question = questionsAndAnswers.find((q) => q.id === ownProps.id);

console.log("array reponses à la question", question.reponses);

return {
question,
questionsAndAnswers: state.questionsAndAnswers.questionsAndAnswers,
reasonOfUnsatisfiedResponse: state.questionsAndAnswers.reasonOfUnsatisfiedResponse
};
};

const MapDispatchToProps = (dispatch) => ({
getQuestionsAnswers: () => {
dispatch(getQuestionsAnswers());
},
updateResponse: () => {
dispatch(updateResponse());
},
updateQuestion: (id, state) => {
dispatch(updateQuestion(id, state));
},
setReasonOfUnsatisfiedResponse: (value) => {
dispatch(setReasonOfUnsatisfiedResponse(value));
}
});

export default connect(MapStateToProps, MapDispatchToProps)(YourQuestion);